import { render, staticRenderFns } from "./NoJSExample.vue?vue&type=template&id=1239a2ce&scoped=true&"
import script from "./NoJSExample.vue?vue&type=script&lang=js&"
export * from "./NoJSExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1239a2ce",
  null
  
)

export default component.exports